import { request } from '@/common/utils/request'
export function fetchBizoppDetailBasic(params) {
  return request.get({
    url: 'feidian.bizopp.bdapp.getBizoppBasic',
    params
  })
}
// 获取拜访记录的数据
export function fetchBizoppVisitLogs(params) {
  return request.get({
    url: 'feidian.bdapp.visit.getShopVisitList',
    params
  })
}

// 获取权限
export function getBizoppSwitch (params) {
  return request.get({
    url: 'feidian.bizopp.bdapp.getBizoppSwitch',
    params
  })
}

// 获取按钮权限
export function fetchBizoppButton(params) {
  return request.get({
    url: 'crm.bdapp.bizopp.getDetailButton',
    params
  })
}

// 获取签约失败任务信息
export function fetchBizopPackList(params) {
  return request.get({
    url: 'feidian.bizopp.bdapp.getPackList',
    params
  })
}

// 获取商机全部信息

export function fetchBizoppDetailAllInfo(params) {
  return request.get({
    url: 'feidian.bizopp.bdapp.getBizoppInfo',
    params
  })
}
// 获取经营信息
export function getBusinessInfo (params) {
  return request.get({
    url: 'crm.bdapp.bizopp.getBusinessInfo',
    params
  })
}
// 获取撤销原因
export function getWithdrawReason (params) {
  return request.get({
    url: 'bdapp.sign.config.getWithdrawReason',
    params
  })
}
// 撤销申请签约
export function getWithdrawSign (params) {
  let url = ''
  if (params.applyId) {
    url = 'bdapp.contractor.append.withdraw'
  } else {
    url = 'bdapp.contractor.open.withdraw'
  }
  return request.post({
    url: url,
    data: params
  })
}
/** 以下是油站的API */
export function fetchGasBizoppDetail(params) {
  return request.get({
    url: 'feidian.gas.bizopp.bdapp.getDetail',
    params
  })
}

export function fetchGasConfigByKeys(params) {
  return request.get({
    url: 'feidian.gas.bizopp.bdapp.getConfigByKeys',
    params
  })
}
